import { render, staticRenderFns } from "./OrderConfirmation.vue?vue&type=template&id=a03ca9f8&scoped=true&"
import script from "./OrderConfirmation.vue?vue&type=script&lang=js&"
export * from "./OrderConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./OrderConfirmation.vue?vue&type=style&index=0&id=a03ca9f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a03ca9f8",
  null
  
)

export default component.exports